import Iconify from "../ui/Iconify";
import { PopularSearchItem } from "./popular-search-parts";
import { hasRealPopularSearches } from "./popular-search-data";

// 실제 검색량이 쌓이기 전에는 '추천 검색어'로 부른다. 서버가 frequency 를
// 채워 보내기 시작하면 문구·순위·기준시각이 자동으로 돌아온다(2026-07-31 ㉮).
const MobilePopularSearchPanel = ({ popularItems, updatedAt, onSubmit }) => {
  const hasRealPopularity = hasRealPopularSearches(popularItems);

  return (
  <section>
    <div className="mb-3 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <Iconify
          icon="lucide:trending-up"
          className="!h-5 !w-5 text-black/35 dark:text-white/45"
        />
        <h2 className="text-[18px] font-semibold leading-6">
          {hasRealPopularity ? "인기 검색어" : "추천 검색어"}
        </h2>
      </div>
      {hasRealPopularity && (
        <span className="text-[12px] font-medium text-black/40 dark:text-white/40">
          12시간마다 업데이트
        </span>
      )}
    </div>

    <div className="overflow-hidden rounded-2xl border border-black/5 bg-white px-4 py-1 shadow-[0_10px_28px_rgba(15,23,42,0.06)] dark:bg-white/10 dark:border-white/10">
      {popularItems.length > 0 ? (
        popularItems.map((item, index) => (
          <PopularSearchItem
            key={`popular-${item.searchTerm}`}
            item={item}
            index={index}
            total={popularItems.length}
            onSubmit={onSubmit}
            showRanking={hasRealPopularity}
          />
        ))
      ) : (
        <div className="flex min-h-[64px] items-center text-[15px] font-medium text-black/40 dark:text-white/40">
          검색어를 입력해보세요
        </div>
      )}
    </div>
    {popularItems.length > 0 && hasRealPopularity && (
      <div className="pt-1.5 pr-1 text-right text-[11px] font-medium text-black/35 dark:text-white/35">
        {updatedAt} 기준
      </div>
    )}
  </section>
  );
};

export default MobilePopularSearchPanel;
